import axios from "axios";
import routes from "../../configs/api";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";

const downloadSampleTemplate = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);

  return new Promise((resolve, reject) => {
    const URL = routes.DOWNLOAD_SAMPLE_TEMPLATE;
    axios
      .get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob', // Important for file download
      })
      .then((res) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'package-update-template.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default downloadSampleTemplate;